export default {
	app: {
		brand: 'HeySens'
	},
	topbar: {
		settings: 'Cài đặt',
		language: 'Ngôn ngữ'
	},
	locale: {
		zh: '中文',
		vi: 'Tiếng Việt'
	},
	nav: {
		analytics: {
			group: 'Phân tích dữ liệu',
			total: 'Tổng quan',
			chartStats: 'Thống kê biểu đồ',
			test: 'Kiểm tra'
		},
		enterprise: {
			group: 'Quản lý doanh nghiệp',
			config: 'Cấu hình doanh nghiệp',
			notice: 'Phát thông báo'
		},
		events: {
			group: 'Quản lý sự kiện',
			records: 'Bản ghi sự kiện',
			sensors: 'Quản lý thiết bị cảm biến'
		},
		shower: {
			group: 'Quản lý vòi sen',
			recordsStaff: 'Lịch sử tắm (nhân sự)',
			recordsDevice: 'Lịch sử tắm (thiết bị)',
			devices: 'Quản lý thiết bị',
			staff: 'Quản lý nhân sự'
		},
		admin: {
			group: 'Quản trị hệ thống',
			safety: 'Quản lý an toàn',
			logs: 'Quản lý nhật ký'
		},
		help: {
			group: 'Trợ giúp',
			docs: 'Tài liệu'
		}
	},
	common: {
		actions: {
			confirm: 'Xác nhận',
			cancel: 'Hủy',
			save: 'Lưu',
			search: 'Tìm kiếm',
			delete: 'Xóa'
		},
		feedback: {
			error: 'Đã xảy ra lỗi',
			success: 'Thao tác thành công',
			failed: 'Thao tác thất bại'
		}
	},
	chartTable: {
		eventTypeStats: 'Thống kê loại sự kiện',
		filters: {
			yesterday: 'Hôm qua',
			today: 'Hôm nay',
			thisWeek: 'Tuần này',
			thisMonth: 'Tháng này'
		},
		trend: {
			totalCaptures: 'Biểu đồ xu hướng (tổng số ảnh chụp)',
			unsafeCount: 'Biểu đồ xu hướng (số vi phạm)'
		},
		range: {
			oneDay: '1 ngày',
			sevenDays: '7 ngày',
			thirtyDays: '30 ngày'
		},
		messages: {
			maxRangeExceeded: 'Khoảng thời gian không được vượt quá một năm'
		}
	},
	chartDemo: {
		datasetLabel: 'Tập dữ liệu biên độ',
		maxShow: 'Biên độ',
		ultraDist: 'Khoảng cách đo (mm)',
		ultraCount: 'Số điểm lấy mẫu',
		ultraCalc: 'Khoảng cách tính toán (mm)',
		draw: 'Vẽ biểu đồ',
		linearChart: 'Biểu đồ tuyến tính'
	},
	landing: {
		nav: {
			home: 'Trang chủ',
			platform: 'Nền tảng',
			product: 'Sản phẩm',
			resources: 'Tài nguyên',
			about: 'Giới thiệu'
		},
		hero: {
			title: '<span class="font-light block">HeySens</span>Để cảm biến nói Hey',
			description: 'Sed blandit libero volutpat sed cras. Fames ac turpis egestas integer. Placerat in egestas erat...',
			getStarted: 'Bắt đầu'
		},
		features: {
			title: 'Tính năng tuyệt vời',
			subtitle: 'Placerat in egestas erat...',
			easyToUse: {
				title: 'Dễ sử dụng',
				desc: 'Posuere morbi leo urna molestie.'
			},
			freshDesign: {
				title: 'Thiết kế mới mẻ',
				desc: 'Semper risus in hendrerit.'
			},
			wellDocumented: {
				title: 'Tài liệu đầy đủ',
				desc: 'Non arcu risus quis varius quam quisque.'
			},
			responsiveLayout: {
				title: 'Bố cục đáp ứng',
				desc: 'Nulla malesuada pellentesque elit.'
			},
			cleanCode: {
				title: 'Mã sạch',
				desc: 'Condimentum lacinia quis vel eros.'
			},
			darkMode: {
				title: 'Chế độ tối',
				desc: 'Convallis tellus id interdum velit laoreet.'
			},
			readyToUse: {
				title: 'Sẵn sàng sử dụng',
				desc: 'Mauris sit amet massa vitae.'
			},
			modernPractices: {
				title: 'Thực tiễn hiện đại',
				desc: 'Elementum nibh tellus molestie nunc non.'
			},
			privacy: {
				title: 'Quyền riêng tư',
				desc: 'Neque egestas congue quisque.'
			},
			testimonial: {
				name: 'Joséphine Miller',
				company: 'Peak Interactive',
				quote: '“Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.”'
			}
		},
		highlight: {
			title1: 'Mạnh mẽ ở mọi nơi',
			subtitle1: 'Amet consectetur adipiscing elit...',
			feature1: {
				title: 'Congue Quisque Egestas',
				desc: 'Lectus arcu bibendum at varius vel pharetra vel turpis nunc. Eget aliquet nibh praesent tristique magna sit amet purus gravida. Sit amet mattis vulputate enim nulla aliquet.'
			},
			feature2: {
				title: 'Celerisque Eu Ultrices',
				desc: 'Adipiscing commodo elit at imperdiet dui. Viverra nibh cras pulvinar mattis nunc sed blandit libero. Suspendisse in est ante in. Mauris pharetra et ultrices neque ornare aenean euismod elementum nisi.'
			}
		},
		pricing: {
			title: 'Giá cả vô song',
			subtitle: 'Amet consectetur adipiscing elit...',
			perMonth: 'mỗi tháng',
			free: {
				title: 'Miễn phí',
				btn: 'Bắt đầu'
			},
			startup: {
				title: 'Khởi nghiệp',
				btn: 'Dùng thử miễn phí'
			},
			enterprise: {
				title: 'Doanh nghiệp',
				btn: 'Nhận báo giá'
			},
			features: {
				responsive: 'Bố cục đáp ứng',
				pushMessages: 'Tin nhắn đẩy không giới hạn',
				support: '50 Vé hỗ trợ',
				shipping: 'Giao hàng miễn phí'
			}
		},
		footer: {
			company: {
				title: 'Công ty',
				aboutUs: 'Về chúng tôi',
				news: 'Tin tức',
				investorRelations: 'Quan hệ nhà đầu tư',
				careers: 'Tuyển dụng',
				mediaKit: 'Bộ công cụ truyền thông'
			},
			resources: {
				title: 'Tài nguyên',
				getStarted: 'Bắt đầu',
				learn: 'Học tập',
				caseStudies: 'Nghiên cứu tình huống'
			},
			community: {
				title: 'Cộng đồng',
				discord: 'Discord',
				events: 'Sự kiện',
				faq: 'Câu hỏi thường gặp',
				blog: 'Blog'
			},
			legal: {
				title: 'Pháp lý',
				brandPolicy: 'Chính sách thương hiệu',
				privacyPolicy: 'Chính sách bảo mật',
				termsOfService: 'Điều khoản dịch vụ'
			}
		}
	},
	logManage: {
		title: 'Quản lý nhật ký',
		rangePlaceholder: 'Chọn khoảng thời gian',
		export: 'Xuất dữ liệu',
		empty: 'Không tìm thấy nhật ký nào.',
		loading: 'Đang tải dữ liệu nhật ký, vui lòng chờ.',
		exportingTitle: 'Đang xuất dữ liệu',
		exportingMessage: 'Hệ thống đang xuất danh sách nhật ký, vui lòng chờ',
		exportFileName: 'Nhật ký thao tác',
		columns: {
			operationTime: 'Thời gian thao tác',
			userName: 'Tên',
			operator: 'Người thao tác',
			action: 'Nội dung thao tác'
		}
	},
	dashboard: {
		summary: {
			last24Hours: 'Sự kiện mới nhất trong 24 giờ',
			thisWeek: 'Thống kê sự kiện tuần này',
			monthlyReviewed: 'Tổng sự kiện phân tích đám mây trong tháng',
			monthlyViolation: 'Tổng sự kiện vi phạm trong tháng'
		},
		actions: {
			more: 'Xem thêm'
		},
		latestEvents: {
			title: 'Sự kiện mới nhất (Top 10)',
			firstAlarmImage: 'Ảnh cảnh báo',
			type: 'Loại',
			time: 'Thời gian',
			details: 'Chi tiết'
		},
		topN: {
			title: 'Thống kê chưa duyệt trong tháng (Top 10)',
			region: 'Khu vực',
			field: 'Địa điểm',
			enterprise: 'Doanh nghiệp',
			enterprisePrefix: 'Doanh nghiệp: {enterprise}',
			fieldCount: 'Số địa điểm: {count}',
			fieldPrefix: 'Địa điểm: {enterprise}->{field}'
		},
		notifications: {
			title: 'Thông báo',
			system: 'Thông báo hệ thống',
			enterprise: 'Thông báo doanh nghiệp',
			today: 'Hôm nay',
			twoDays: 'Hai ngày',
			oneWeek: 'Một tuần',
			todayTitle: 'Hôm nay {date}',
			yesterdayTitle: 'Hôm qua {date}',
			earlierTitle: 'Sớm hơn'
		},
		detail: {
			title: 'Chi tiết sự kiện',
			firstAlarmImage: 'Ảnh cảnh báo',
			rule: 'Quy tắc',
			testDescription: 'Mô tả chức năng thử nghiệm',
			video: 'Video',
			enterprise: 'Doanh nghiệp',
			field: 'Địa điểm',
			region: 'Khu vực',
			point: 'Điểm',
			cameraIp: 'IP camera',
			violationEvent: 'Sự kiện vi phạm',
			riskLevel: 'Mức rủi ro',
			levelTag: 'Mức {level}',
			captureTime: 'Thời gian chụp',
			auditStatus: 'Trạng thái duyệt',
			compliant: 'Tuân thủ',
			nonCompliant: 'Vi phạm',
			unreviewed: 'Chưa xét duyệt',
			auditRecords: 'Lịch sử duyệt',
			original: 'Ban đầu'
		},
		messages: {
			requestError: 'Lỗi yêu cầu'
		}
	},
	eventRecords: {
		title: 'Truy vấn bản ghi sự kiện',
		filters: {
			enterprise: 'Doanh nghiệp',
			field: 'Địa điểm',
			region: 'Khu vực',
			camera: 'Camera',
			timeRange: 'Chọn khoảng thời gian',
			status: 'Trạng thái',
			eventType: 'Loại sự kiện'
		},
		actions: {
			downloadWord: 'Tải Word',
			downloadExcel: 'Tải Excel',
			details: 'Chi tiết',
			delete: 'Xóa'
		},
		sort: {
			placeholder: 'Sắp xếp theo thời gian',
			newestFirst: 'Thời gian mới đến cũ',
			oldestFirst: 'Thời gian cũ đến mới'
		},
		list: {
			field: 'Địa điểm',
			region: 'Khu vực',
			camera: 'Camera',
			eventType: 'Loại sự kiện',
			noRegion: '[Không có khu vực]'
		},
		status: {
			compliant: 'Tuân thủ',
			nonCompliant: 'Vi phạm',
			unreviewed: 'Chưa xét duyệt',
			deleted: 'Xóa',
			pendingAudit: 'Chờ duyệt',
			all: 'Tất cả',
			audited: 'Đã duyệt'
		},
		detail: {
			title: 'Chi tiết sự kiện',
			firstAlarmImage: 'Ảnh cảnh báo',
			rule: 'Quy tắc',
			video: 'Video',
			enterprise: 'Doanh nghiệp',
			field: 'Địa điểm',
			region: 'Khu vực',
			point: 'Điểm',
			cameraIp: 'IP Camera',
			captureTime: 'Thời gian chụp',
			auditStatus: 'Trạng thái duyệt',
			violationEvent: 'Sự kiện vi phạm',
			selectEventType: 'Chọn loại sự kiện',
			riskLevel: 'Mức rủi ro',
			selectRiskLevel: 'Chọn mức rủi ro',
			levelTag: 'Mức {level}',
			violationJudgment: 'Phán quyết vi phạm',
			compliantBtn: 'Tuân thủ',
			nonCompliantBtn: 'Vi phạm',
			compliantPlaceholder: 'Có thể nhập ý kiến "tuân thủ", hoặc để trống',
			nonCompliantPlaceholder: 'Có thể nhập ý kiến "vi phạm", hoặc để trống',
			auditRecords: 'Lịch sử duyệt',
			original: 'Ban đầu',
			confirmDeleteRecord: 'Bạn có chắc chắn muốn xóa bản ghi duyệt này không?',
			continueReview: 'Tiếp tục duyệt',
			previous: 'Bản trước',
			next: 'Bản tiếp theo'
		},
		downloadDialog: {
			title: 'Đang tải tệp',
			message: 'Tệp đang được tải xuống, vui lòng không đóng cửa sổ này hoặc làm mới trang'
		},
		messages: {
			requestError: 'Lỗi yêu cầu',
			operationFailed: 'Thao tác thất bại',
			confirmSuccess: 'Xác nhận thành công',
			parameterError: 'Lỗi tham số',
			networkError: 'Lỗi mạng',
			unknownFile: 'Tệp không xác định',
			confirmCompliant: 'Xác nhận tuân thủ?',
			confirmNonCompliant: 'Xác nhận vi phạm?'
		}
	},
	sensorManage: {
		title: 'Quản lý thiết bị cảm biến',
		addCamera: 'Thêm camera',
		export: 'Xuất',
		import: 'Nhập',
		downloadTemplate: 'Tải mẫu',
		search: 'Tìm kiếm',
		placeholders: {
			enterprise: 'Doanh nghiệp trực thuộc',
			field: 'Sân bãi trực thuộc',
			region: 'Khu vực trực thuộc',
			cameraName: 'Tên camera'
		},
		table: {
			empty: 'Không tìm thấy dữ liệu cảm biến.',
			loading: 'Đang tải dữ liệu cảm biến. Vui lòng chờ.',
			name: 'Tên camera',
			ip: 'IP',
			enterprise: 'Doanh nghiệp',
			field: 'Sân bãi',
			region: 'Khu vực',
			account: 'Tên người dùng',
			password: 'Mật khẩu',
			push: 'Đẩy',
			actions: 'Thao tác',
			edit: 'Chỉnh sửa',
			delete: 'Xóa'
		},
		dialogs: {
			add: 'Thêm camera',
			edit: 'Chỉnh sửa camera',
			cameraPosition: 'Vị trí camera',
			cameraName: 'Tên camera',
			videoUrl: 'Địa chỉ luồng video',
			cameraIp: 'IP camera',
			account: 'Tài khoản',
			password: 'Mật khẩu',
			judgeRule: 'Quy tắc duyệt',
			exportingTitle: 'Đang xuất',
			exportingMessage: 'Hệ thống đang xuất danh sách camera, vui lòng chờ',
			viewRule: 'Xem quy tắc',
			editRule: 'Chỉnh sửa quy tắc',
			runTime: 'Thời gian chạy',
			startTime: 'Thời gian bắt đầu',
			endTime: 'Thời gian kết thúc',
			pushFeature: 'Chức năng đẩy',
			pushRule: 'Quy tắc đẩy'
		},
		ruleHints: {
			withinMinutes: 'phút, cảnh báo',
			stopAfterTimes: 'lần, dừng gửi cảnh báo',
			resumeAfterMinutes: 'phút sau, tiếp tục gửi'
		},
		validation: {
			cameraName: 'Vui lòng nhập tên đúng, gồm tiếng Trung hoặc tiếng Anh',
			videoUrl: 'Vui lòng nhập địa chỉ luồng video đúng',
			cameraIp: 'Vui lòng nhập địa chỉ IP đúng',
			account: 'Vui lòng nhập thông tin tài khoản đúng',
			password: 'Vui lòng nhập mật khẩu đúng'
		},
		confirmDelete: 'Bạn có chắc chắn muốn xóa camera này không?',
		exportFileName: 'Quản lý camera',
		templateFileName: 'Mẫu nhập camera',
		pushLabels: {
			push: 'Đẩy',
			noPush: 'Không đẩy'
		},
		templateColumns: [
			'Tên camera',
			'IP camera',
			'Khu vực trực thuộc',
			'Vị trí trực thuộc',
			'Tên doanh nghiệp',
			'Sân bãi trực thuộc',
			'Tên người dùng',
			'Mật khẩu',
			'Địa chỉ luồng video',
			'Có đẩy hay không (0 đẩy 1 không đẩy)'
		],
		importSuccess: 'Nhập thành công'
	},
	notifyManage: {
		title: 'Quản lý thông báo',
		publish: 'Phát hành',
		empty: 'Không có dữ liệu thông báo.',
		loading: 'Đang tải dữ liệu thông báo, vui lòng chờ.',
		columns: {
			content: 'Nội dung',
			type: 'Loại',
			publishedAt: 'Thời gian phát hành',
			actions: 'Thao tác'
		},
		types: {
			system: 'Hệ thống',
			enterprise: 'Doanh nghiệp'
		},
		dialog: {
			title: 'Phát hành thông báo',
			rule: 'Quy tắc',
			selectType: 'Chọn loại',
			selectEnterprisePermission: 'Chọn quyền doanh nghiệp',
			content: 'Nội dung (giới hạn 140 ký tự)'
		},
		messages: {
			selectType: 'Vui lòng chọn loại thông báo',
			selectEnterprise: 'Vui lòng chọn doanh nghiệp',
			confirmDelete: 'Bạn có chắc chắn muốn xóa thông báo này không?'
		}
	},
	notifyList: {
		empty: 'Không có thông báo mới',
		loading: 'Đang tải dữ liệu thông báo, vui lòng chờ.',
		columns: {
			index: 'STT',
			content: 'Nội dung',
			type: 'Loại',
			publishedAt: 'Thời gian phát hành'
		}
	},
	groupConfig: {
		searchPlaceholder: 'Tìm kiếm từ khóa',
		add: 'Thêm mới',
		enterpriseName: 'Tên doanh nghiệp',
		managerAccount: 'Tài khoản quản trị',
		password: 'Mật khẩu',
		empty: 'Không có dữ liệu doanh nghiệp.',
		loading: 'Đang tải dữ liệu doanh nghiệp, vui lòng chờ.',
		columns: {
			enterprise: 'Doanh nghiệp',
			actions: 'Thao tác'
		},
		selectEnterpriseHint: '<< Nhấp vào doanh nghiệp bên trái để hiển thị thông tin địa điểm',
		validation: {
			enterpriseName: 'Vui lòng nhập đúng tên doanh nghiệp, gồm tiếng Trung, tiếng Anh hoặc số',
			managerAccount: 'Vui lòng nhập đúng tài khoản quản trị',
			password: 'Vui lòng nhập mật khẩu dài hơn 6 ký tự'
		},
		dialogs: {
			addEnterprise: 'Thêm doanh nghiệp',
			editEnterprise: 'Chỉnh sửa doanh nghiệp',
			addCluster: 'Thêm cụm',
			editCluster: 'Chỉnh sửa cụm'
		},
		messages: {
			requestError: 'Lỗi yêu cầu',
			selectParentEnterprise: 'Vui lòng chọn doanh nghiệp cha',
			confirmDeleteEnterprise: 'Xác nhận xóa doanh nghiệp?',
			confirmDeleteCluster: 'Xác nhận xóa cụm?',
			operationSuccess: 'Thao tác "{name}" thành công',
			deleteSuccess: 'Xóa "{name}" thành công'
		}
	},
	login: {
		welcome: 'Chào mừng đến với HeySens!',
		subtitle: 'Đăng nhập để tiếp tục',
		username: 'Tên đăng nhập',
		password: 'Mật khẩu',
		signIn: 'Đăng nhập',
		submitError: 'Gửi biểu mẫu thất bại',
		icpRecord: '粤ICP备2022095255号-2',
		logoAlt: 'Biểu trưng HeySens'
	},
	documentPage: {
		title: 'Hướng dẫn sử dụng',
		placeholder: 'Đang hoàn thiện, sẽ sớm phát hành'
	},
	showerRecords: {
		titleByPerson: 'Lịch sử tắm (theo nhân sự)',
		titleByDevice: 'Lịch sử tắm (theo thiết bị)',
		filters: {
			enterprise: 'Doanh nghiệp trực thuộc',
			field: 'Địa điểm trực thuộc',
			region: 'Khu vực trực thuộc',
			timeRange: 'Chọn khoảng thời gian',
			sn: 'SN'
		},
		actions: {
			query: 'Tra cứu',
			excelDownload: 'Tải Excel',
			hideUsers: 'Ẩn người dùng',
			showUsers: 'Hiện người dùng'
		},
		header: {
			total: 'Tổng số: {count}',
			id: 'ID: {id}',
			name: 'Tên: {name}',
			height: 'Chiều cao: {height} cm',
			phone: 'Số điện thoại: {phone}'
		},
		tabs: {
			all: 'Tất cả',
			violation: 'Vi phạm',
			noShower: 'Chưa tắm'
		},
		states: {
			empty: 'Không có lịch sử tắm',
			loading: 'Đang làm mới, vui lòng chờ...',
			qualified: 'Đạt chuẩn',
			nonCompliant: 'Vi phạm',
			anonymousUser: 'Người dùng ẩn danh'
		},
		columns: {
			name: 'Tên',
			height: 'Chiều cao',
			count: 'Số lần',
			record: 'Bản ghi',
			time: 'Thời gian',
			location: 'Vị trí',
			deviceName: 'Tên vòi sen',
			compliance: 'Tuân thủ',
			totalDuration: 'Tổng thời lượng',
			headDuration: 'Thời lượng đầu',
			validDuration: 'Thời lượng hợp lệ',
			noPerson: 'Không có người dưới vòi',
			noWater: 'Ngắt nước giữa chừng',
			shampoo: 'Gội đầu',
			bodyWash: 'Tắm',
			waterTemp: 'Nhiệt độ nước',
			signal: 'Tín hiệu',
			totalWater: 'Tổng lượng nước'
		},
		download: {
			title: 'Đang tải tệp',
			message: 'Tệp đang được tải xuống, vui lòng không đóng cửa sổ này hoặc làm mới trang',
			confirmExcel: 'Xác nhận tải báo cáo Excel?',
			reportName: 'Báo cáo tắm',
			tooManyRecords: 'Số lượng thống kê lớn hơn 1000, hiện chưa hỗ trợ tải xuống'
		},
		messages: {
			dataError: 'Lỗi dữ liệu',
			requestError: 'Lỗi yêu cầu',
			networkError: 'Lỗi mạng'
		},
		units: {
			times: 'lần',
			liters: 'lít',
			minutes: 'phút',
			seconds: 'giây'
		}
	},
	showerStaff: {
		title: 'Quản lý nhân sự vòi sen',
		addStaff: 'Thêm nhân sự',
		generateNumber: 'Tạo mã số',
		filters: {
			enterprise: 'Doanh nghiệp trực thuộc',
			field: 'Địa điểm trực thuộc',
			name: 'Tên'
		},
		header: {
			total: 'Tổng số: {count}'
		},
		states: {
			empty: 'Không có hồ sơ nhân sự',
			loading: 'Đang làm mới, vui lòng chờ...'
		},
		columns: {
			name: 'Tên',
			territory: 'Khu vực trực thuộc',
			height: 'Chiều cao',
			phone: 'Số điện thoại',
			actions: 'Thao tác'
		},
		dialog: {
			addTitle: 'Thêm nhân sự',
			territory: 'Khu vực trực thuộc',
			staffName: 'Tên nhân sự',
			height: 'Chiều cao',
			phone: 'Số điện thoại'
		},
		messages: {
			invalidPhone: 'Số điện thoại không hợp lệ',
			unsupportedHeight: 'Chiều cao không được hỗ trợ',
			fillName: 'Vui lòng nhập tên',
			selectEnterprise: 'Vui lòng chọn doanh nghiệp',
			selectField: 'Vui lòng chọn địa điểm',
			confirmDelete: 'Bạn có chắc chắn muốn xóa người dùng này không?'
		},
		export: {
			push: 'Đẩy',
			noPush: 'Không đẩy',
			cameraName: 'Tên camera',
			cameraIp: 'IP camera',
			videoUrl: 'Địa chỉ luồng video',
			username: 'Tên đăng nhập',
			password: 'Mật khẩu',
			field: 'Địa điểm trực thuộc',
			region: 'Khu vực chi tiết',
			pushStatus: 'Trạng thái đẩy',
			enterpriseName: 'Tên doanh nghiệp',
			position: 'Vị trí trực thuộc',
			pushTemplateHint: 'Trạng thái đẩy (0 đẩy / 1 không đẩy)',
			cameraManageFile: 'Quản lý camera',
			cameraImportTemplate: 'Mẫu nhập camera'
		}
	},
	showerDevice: {
		title: 'Quản lý thiết bị vòi sen',
		search: 'Tra cứu',
		edit: 'Chỉnh sửa',
		filters: {
			enterprise: 'Doanh nghiệp trực thuộc',
			field: 'Địa điểm trực thuộc',
			region: 'Khu vực trực thuộc',
			onlineStatus: 'Trạng thái trực tuyến',
			deployStatus: 'Trạng thái triển khai',
			sn: 'SN'
		},
		header: {
			total: 'Tổng số: {count}'
		},
		states: {
			empty: 'Không tìm thấy thiết bị vòi sen, có thể liên hệ Shenzhen Jiyuan Digital để mua',
			loading: 'Đang làm mới, vui lòng chờ...',
			offline: 'Ngoại tuyến',
			online: 'Trực tuyến',
			high: 'Cao',
			low: 'Thấp',
			all: 'Tất cả',
			notDeployed: 'Chưa triển khai',
			deployed: 'Đã triển khai',
			wiredNetwork: 'Mạng có dây'
		},
		columns: {
			version: 'Phiên bản',
			deviceName: 'Tên vòi sen',
			location: 'Vị trí',
			online: 'Trực tuyến',
			lastHeartbeat: 'Nhịp tim gần nhất',
			shampoo: 'Dầu gội',
			bodyWash: 'Sữa tắm',
			roomTemp: 'Nhiệt độ phòng',
			waterFlowThreshold: 'Ngưỡng lưu lượng nước',
			actions: 'Thao tác'
		},
		dialog: {
			editTitle: 'Chỉnh sửa thiết bị',
			deviceLocation: 'Vị trí thiết bị',
			deviceName: 'Tên thiết bị',
			basicParams: 'Thông số cơ bản',
			height: 'Chiều cao vòi trên (cm)',
			minWaterFlow: 'Lưu lượng nước tối thiểu (L/phút)',
			headDuration: 'Thời lượng phần đầu (giây)',
			validDuration: 'Thời lượng hợp lệ (giây)',
			shampooCount: 'Số lần dầu gội',
			bodyWashCount: 'Số lần sữa tắm',
			advancedParams: 'Thông số nâng cao',
			networkType: 'Mạng ngoài',
			doorControlType: 'Loại kiểm soát cửa',
			detectionLevel: 'Mức phát hiện',
			customized: 'Tùy chỉnh',
			customizedProgram: 'Chương trình tùy chỉnh',
			userParams: 'Thông số người dùng',
			enableAnonymous: 'Bật chế độ ẩn danh (mở nước là tắm)',
			enableEasy: 'Bật chế độ Easy',
			validTimeEasy: 'Bật Easy khi thời gian hợp lệ vượt quá (giây)',
			totalTimeEasy: 'Bật Easy khi tổng thời gian vượt quá (giây)',
			anonymousHeight: 'Chiều cao ẩn danh (cm)',
			showerType: 'Loại tắm',
			bubbleParams: 'Thông số máy bọt',
			enableBubble: 'Bật máy bọt',
			bubbleUsageCount: 'Số lần dùng bọt',
			startTimer: 'Thời gian bắt đầu tính (giây)',
			bubbleDuration: 'Thời lượng bọt (giây)',
			bubbleBeforeRinseTime: 'Thời gian xả trước tạo bọt (giây)',
			bubbleAfterRinseTime: 'Thời gian xả sau tạo bọt (giây)',
			bubbleAfterScrubTime: 'Thời gian chà rửa sau tạo bọt (giây)',
			algorithmType: 'Loại thuật toán',
			note: 'Ghi chú'
		},
		messages: {
			invalidHeight: 'Chiều cao vòi sen không hợp lệ',
			invalidHeadDuration: 'Thời lượng phần đầu không hợp lệ',
			invalidValidDuration: 'Thời lượng hợp lệ không hợp lệ',
			invalidBodyWashDuration: 'Thời lượng sữa tắm không hợp lệ',
			invalidShampooDuration: 'Thời lượng dầu gội không hợp lệ',
			invalidBubbleBeforeRinseTime: 'Thời gian xả trước tạo bọt không hợp lệ',
			invalidBubbleAfterRinseTime: 'Thời gian xả sau tạo bọt không hợp lệ',
			invalidBubbleAfterScrubTime: 'Thời gian chà rửa sau tạo bọt không hợp lệ',
			invalidWaterFlow: 'Ngưỡng lưu lượng nước không hợp lệ',
			unsupportedHeight: 'Chiều cao vòi sen không được hỗ trợ',
			unsupportedWaterFlow: 'Lưu lượng nước không được hỗ trợ'
		},
		units: {
			litersPerMinute: 'lít/phút'
		}
	},
	saferManage: {
		title: 'Quản lý an toàn viên',
		add: 'Thêm mới',
		searchPlaceholder: 'Tra cứu từ khóa',
		empty: 'Không có dữ liệu an toàn viên.',
		loading: 'Đang tải dữ liệu an toàn viên, vui lòng chờ.',
		columns: {
			name: 'Tên',
			phone: 'Số liên hệ',
			type: 'Loại',
			status: 'Trạng thái',
			actions: 'Thao tác'
		},
		types: {
			enterpriseUser: 'Người dùng doanh nghiệp',
			safer: 'An toàn viên'
		},
		dialog: {
			role: 'Vai trò',
			selectUserType: 'Chọn loại người dùng',
			selectEnterprisePermission: 'Chọn quyền doanh nghiệp',
			name: 'Tên',
			phone: 'Điện thoại',
			password: 'Mật khẩu'
		},
		validation: {
			name: 'Vui lòng nhập đúng tên, gồm chữ Trung hoặc chữ cái Latin',
			phone: 'Vui lòng nhập đúng số điện thoại',
			password: 'Vui lòng nhập mật khẩu dài hơn 6 ký tự'
		},
		messages: {
			confirmDelete: 'Bạn có chắc chắn muốn xóa an toàn viên này không?'
		}
	},
	reportDownload: {
		title: 'Tải báo cáo',
		timeRange: 'Chọn khoảng thời gian',
		export: 'Xuất dữ liệu',
		empty: 'Không có dữ liệu báo cáo.',
		loading: 'Đang tải dữ liệu báo cáo, vui lòng chờ.',
		columns: {
			reportTime: 'Thời gian báo cáo',
			reporter: 'Người báo cáo',
			summary: 'Tóm tắt nội dung',
			download: 'Tải xuống'
		},
		exportingTitle: 'Đang xuất dữ liệu',
		exportingMessage: 'Hệ thống đang xuất danh sách nhật ký, vui lòng chờ',
		exportFileName: 'Nhật ký thao tác'
	},
	roleManage: {
		title: 'Quản lý vai trò',
		searchPlaceholder: 'Mã nhân sự',
		roleName: 'Tên vai trò',
		permission: 'Quyền hạn',
		status: 'Trạng thái',
		confirmDelete: 'Bạn có chắc chắn muốn xóa vai trò này không?',
		addTitle: 'Thêm vai trò',
		editTitle: 'Chỉnh sửa vai trò',
		validation: {
			roleName: 'Vui lòng nhập đúng tên vai trò, gồm chữ Trung, chữ cái Latin hoặc số'
		}
	},
	employeeManage: {
		searchTitle: 'Tra cứu nhân viên',
		addEmployee: 'Thêm nhân viên',
		empty: 'Không có dữ liệu.',
		loading: 'Đang tải dữ liệu, vui lòng chờ.',
		id: 'ID',
		post: 'Chức vụ trực thuộc',
		name: 'Tên',
		phone: 'Điện thoại',
		contactPhone: 'Số liên hệ',
		password: 'Mật khẩu',
		status: 'Trạng thái',
		routePermission: 'Quyền tuyến',
		dataPermission: 'Quyền dữ liệu',
		addTitle: 'Thêm nhân viên',
		editTitle: 'Chỉnh sửa nhân viên',
		confirmDelete: 'Bạn có chắc chắn muốn xóa nhân viên này không?',
		validation: {
			name: 'Vui lòng nhập đúng tên, gồm chữ Trung hoặc chữ cái Latin',
			phone: 'Vui lòng nhập đúng số điện thoại',
			password: 'Vui lòng nhập mật khẩu dài hơn 6 ký tự'
		}
	},
	fieldConfig: {
		addField: 'Thêm địa điểm',
		searchPlaceholder: 'Tra cứu từ khóa',
		dialogs: {
			addField: 'Thêm địa điểm',
			editField: 'Chỉnh sửa địa điểm',
			enterprise: 'Doanh nghiệp trực thuộc',
			fieldClass: 'Phân khu địa điểm',
			fieldName: 'Tên địa điểm',
			contact: 'Người liên hệ',
			contactNumber: 'Thông tin liên hệ',
			location: 'Vị trí',
			locate: 'Định vị',
			regionManage: 'Quản lý khu vực',
			addRegion: 'Thêm khu vực',
			editRegion: 'Chỉnh sửa khu vực',
			regionName: 'Tên khu vực',
			positionManage: 'Quản lý vị trí',
			addPosition: 'Thêm vị trí',
			editPosition: 'Chỉnh sửa vị trí',
			parentRegion: 'Khu vực trực thuộc',
			positionName: 'Tên vị trí'
		},
		validation: {
			fieldClass: 'Vui lòng nhập đúng phân khu địa điểm, gồm chữ Trung, chữ cái Latin hoặc số',
			fieldName: 'Vui lòng nhập đúng tên địa điểm, gồm chữ Trung, chữ cái Latin hoặc số',
			contact: 'Vui lòng nhập đúng tên liên hệ, gồm chữ Trung, chữ cái Latin hoặc số',
			contactNumber: 'Vui lòng nhập đúng số điện thoại',
			regionName: 'Vui lòng nhập đúng tên khu vực, gồm chữ Trung, chữ cái Latin hoặc số',
			positionName: 'Vui lòng nhập đúng tên vị trí, gồm chữ Trung, chữ cái Latin hoặc số'
		},
		states: {
			empty: 'Không có dữ liệu.',
			loading: 'Đang tải dữ liệu, vui lòng chờ.'
		},
		columns: {
			fieldName: 'Tên địa điểm',
			contact: 'Người liên hệ',
			contactNumber: 'Thông tin liên hệ',
			actions: 'Thao tác',
			id: 'ID',
			regionName: 'Tên khu vực',
			belongField: 'Địa điểm trực thuộc',
			positionName: 'Tên vị trí'
		},
		actions: {
			region: 'Khu vực',
			edit: 'Chỉnh sửa',
			delete: 'Xóa'
		},
		messages: {
			confirmDeleteField: 'Bạn có chắc chắn muốn xóa địa điểm này không?',
			confirmDeleteRegion: 'Bạn có chắc chắn muốn xóa khu vực này không?',
			confirmDeletePosition: 'Bạn có chắc chắn muốn xóa vị trí này không?',
			productSelected: 'Đã chọn mục',
			productUnselected: 'Đã bỏ chọn mục',
			fileUploaded: 'Đã tải tệp lên'
		}
	},
	clusterConfig: {
		viewFields: 'Xem địa điểm',
		searchPlaceholder: 'Tra cứu từ khóa',
		empty: 'Không có dữ liệu.',
		loading: 'Đang tải dữ liệu, vui lòng chờ.',
		columns: {
			clusterName: 'Tên cụm',
			contact: 'Người liên hệ',
			contactNumber: 'Thông tin liên hệ',
			actions: 'Thao tác'
		},
		actions: {
			field: 'Địa điểm',
			edit: 'Chỉnh sửa',
			delete: 'Xóa'
		},
		dialog: {
			enterpriseName: 'Tên doanh nghiệp',
			managerAccount: 'Tài khoản quản trị',
			password: 'Mật khẩu',
			addTitle: 'Thêm cụm',
			editTitle: 'Chỉnh sửa cụm'
		},
		validation: {
			enterpriseName: 'Vui lòng nhập đúng tên doanh nghiệp, gồm chữ Trung, chữ cái Latin hoặc số',
			managerAccount: 'Vui lòng nhập đúng tài khoản quản trị',
			password: 'Vui lòng nhập mật khẩu dài hơn 6 ký tự'
		},
		messages: {
			selectParentEnterprise: 'Vui lòng chọn doanh nghiệp cha',
			confirmDelete: 'Xác nhận xóa cụm?'
		}
	},
	areaConfig: {
		back: 'Quay lại',
		addRegion: 'Thêm khu vực',
		searchPlaceholder: 'Tra cứu từ khóa',
		dialogTitle: 'Thêm khu vực',
		enterprise: 'Doanh nghiệp trực thuộc',
		regionName: 'Tên khu vực',
		invalidAccount: 'Tài khoản không hợp lệ',
		empty: 'Không có dữ liệu.',
		loading: 'Đang tải dữ liệu, vui lòng chờ.',
		columns: {
			regionName: 'Tên khu vực',
			fieldName: 'Địa điểm trực thuộc',
			settings: 'Thiết lập',
			actions: 'Thao tác'
		},
		actions: {
			edit: 'Chỉnh sửa',
			delete: 'Xóa'
		}
	}
};
